module.exports = __webpack_public_path__ + "static/media/stru1.0a7f8850.jpg";